<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col
          md="12"
          class="text-left"
        >
          <b-list-group>
            <b-list-group-item variant="danger">
              <strong>Internet Explorer는 이용 불가 합니다(Internet Explorer is not supported)</strong>
            </b-list-group-item>
            <b-list-group-item>
              &nbsp;&nbsp;&nbsp;&nbsp; Recommended: 크롬(Chrome), 웨일(Whale), 사파리(Safari), 핸드폰(Mobile)로 이용해주세요
            </b-list-group-item>
            <b-list-group-item variant="primary">
              <strong>기탁장학금 입금 계좌 안내</strong>
            </b-list-group-item>
            <b-list-group-item>
              &nbsp;&nbsp;&nbsp;&nbsp;농협 355-0029-3069-33 임마누엘서울교회, 우리은행 1005-501-570927 임마누엘서울교회
            </b-list-group-item>
            <b-list-group-item variant="primary">
              <strong>홈페이지 문의(Contact to report issues)</strong>
            </b-list-group-item>
            <b-list-group-item>
              &nbsp;&nbsp;&nbsp;&nbsp; 장학부 부서
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-show="$store.getters.isRemnant || $store.getters.isSuper">
      <b-row>
        <b-col
          md="6"
          class="text-center"
        >
          <b-button
            size="lg"
            variant="outline-success"
            @click="$router.push('/apply/regist')"
          >
            <h1>
              장학금 신청하기
              <b-badge variant="primary">
                클릭!
              </b-badge>
            </h1>
          </b-button>
        </b-col>
        <b-col
          md="6"
          class="text-center"
        >
          <b-button
            size="lg"
            variant="outline-info"
            @click="$router.push('/donate/regist')"
          >
            <h1>
              장학금 기탁하기
              <b-badge variant="primary">
                클릭!
              </b-badge>
            </h1>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <div slot="header">
        <strong>2026 상반기</strong>
      </div>
      <b-row>
        <b-col cols="12">
          <a
            href="https://photos.app.goo.gl/s8aAVdii18t5yy4f8"
            target="_blank"
          >
            <b-card
              overlay
              img-src="https://lh3.googleusercontent.com/pw/AP1GczOnQcNKtDA8mpZ0Z90-5curm2w3G2nIMVaBtQbBezdLwPuD7dlDkPp4riIRrM8Sm4Yx5YsNPWLLKxvpPNj9JMYWCbkfRFbmg6WVcAAG4oCvc5BhAroW3O_pAtOmnuHHcTaUR_kqn750Kv3drdjV1eo=w2118-h1412-s-no-gm?authuser=0"
              img-alt="Card Image"
              text-variant="white"
              title="2026 상반기 앨범 보기(Click!)"
            />
          </a>
        </b-col>
      </b-row>
      <!-- 장학부 메인 화면 내 장학생 인터뷰 유튜브 영상을 임시로 노출 중지함 -->
      <!-- <b-row>
        <b-col
          v-for="videoId in videoIds"
          :key="videoId"
          md="6"
          class="text-center"
        >
          <div>
            <youtube
              ref="youtube"
              :resize="true"
              :fit-parent="true"
              :video-id="videoId"
            />
          </div>
        </b-col>
      </b-row> -->
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  data: function () {
    return {
      videoIds: ['5Ph6j-_qqw8']
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
